import _objectSpread from "/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "/Users/moesalih/Documents/GitHub/moesalih/elliss/elliss-react/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["accentColor"];
import { baseTheme } from "./chunk-UGTEAKKT.js"; // src/themes/darkTheme.ts

var accents = {
  blue: "#3898FF",
  green: "#4BD166",
  orange: "#FF983D",
  pink: "#FF7AB8",
  purple: "#7A70FF",
  red: "#FF6257",
  yellow: "#FFDF3D"
};

var darkTheme = function darkTheme() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$accentColor = _ref.accentColor,
      accentColor = _ref$accentColor === void 0 ? "blue" : _ref$accentColor,
      baseThemeOptions = _objectWithoutProperties(_ref, _excluded);

  return _objectSpread(_objectSpread({}, baseTheme(baseThemeOptions)), {}, {
    borders: {
      modalBorderWidth: "1px"
    },
    colors: {
      accentColor: accents[accentColor],
      actionButtonBorder: "rgba(255, 255, 255, 0.04)",
      actionButtonBorderMobile: "rgba(0, 0, 0, 0)",
      actionButtonSecondaryBackground: "rgba(255, 255, 255, 0.08)",
      actionButtonText: "#FFF",
      closeButton: "rgba(224, 232, 255, 0.6)",
      closeButtonBackground: "rgba(255, 255, 255, 0.08)",
      connectButtonBackground: "#1A1B1F",
      connectButtonBackgroundError: "#FF494A",
      connectButtonInnerBackground: "linear-gradient(0deg, rgba(255, 255, 255, 0.075), rgba(255, 255, 255, 0.15))",
      connectButtonText: "#FFF",
      connectButtonTextError: "#FFF",
      connectionIndicator: "#30E000",
      error: "#FF494A",
      generalBorder: "rgba(255, 255, 255, 0.08)",
      generalBorderDim: "rgba(255, 255, 255, 0.04)",
      menuItemBackground: "rgba(224, 232, 255, 0.1)",
      modalBackdrop: "rgba(0, 0, 0, 0.5)",
      modalBackground: "#1A1B1F",
      modalBorder: "rgba(255, 255, 255, 0.08)",
      modalText: "#FFF",
      modalTextDim: "rgba(224, 232, 255, 0.3)",
      modalTextSecondary: "rgba(255, 255, 255, 0.6)",
      profileAction: "rgba(224, 232, 255, 0.1)",
      profileActionHover: "rgba(224, 232, 255, 0.2)",
      profileForeground: "rgba(224, 232, 255, 0.05)",
      selectedOptionBorder: "rgba(224, 232, 255, 0.1)",
      standby: "#FFD641"
    },
    shadows: {
      connectButton: "0px 4px 12px rgba(0, 0, 0, 0.1)",
      dialog: "0px 8px 32px rgba(0, 0, 0, 0.32)",
      profileDetailsAction: "0px 2px 6px rgba(37, 41, 46, 0.04)",
      selectedOption: "0px 2px 6px rgba(0, 0, 0, 0.24)",
      selectedWallet: "0px 2px 6px rgba(0, 0, 0, 0.24)"
    }
  });
};

export { darkTheme };